import Vue from 'vue'
import App from './App.vue'
import router from './router'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import '@fortawesome/fontawesome-free/css/all.css'
import '@fortawesome/fontawesome-free/js/all.js'
import 'devextreme/dist/css/dx.common.css';
import 'devextreme/dist/css/dx.light.css';
import svc, { ApiClient } from '@/services/$svc';
import { DxGridColumnConfig } from './services/$gridColumnsProvider'
import entitiesGridColumns from './services/$gridColumnsProvider';
// Import component
import Loading from 'vue-loading-overlay';
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css';
import { ModalPlugin } from 'bootstrap-vue';
import DataGrid from '@/components/DataGrid.vue';


// Init plugin
Vue.use(Loading)
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.use(ModalPlugin)

Vue.component('DataGrid', DataGrid);

declare module 'vue/types/vue' {
  interface VueConstructor {
      $svc: ApiClient;
      $gridColumnsProvider: {
        [key: string]: DxGridColumnConfig[];
      };
      $loading: any;
  }
}
Vue.$svc = svc;
Vue.$gridColumnsProvider = entitiesGridColumns;

Object.defineProperty(Vue.prototype, '$api', {
  get () {
    return svc;
  }
});
Object.defineProperty(Vue.prototype, '$gridColumnsProvider', {
  get () {
    return entitiesGridColumns;
  }
});

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
